import Vue from 'vue'
import VueRouter from 'vue-router'

// 进度条
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'

import store from '@/store'
import util from '@/libs/util.js'
import common from '@/pages/common/router'
import account from '@/pages/account/router'
import service from '@/pages/account/service.js'

// 路由数据
const frameInRoutes = require('@/project/routes.js')

Vue.use(VueRouter)

// 导出路由 在 main.js 里使用
const router = new VueRouter({
  mode: 'history',
  routes: [
    ...frameInRoutes.default,
    ...account,
    ...common
  ]
})

/**
 * 路由拦截
 * 权限验证
 */
router.beforeEach(async (to, from, next) => {
  // HOS OAuth2单点登录检测
  // 检测URL中是否有HOS门户参数windowId，且没有token
  const windowId = to.query.windowId
  const token = util.cookies.get('token')

  if (windowId && !token && to.path === '/') {
    try {
      // 检查OAuth2是否启用
      const res = await service.checkOAuth2Enabled()
      if (res && res.success && res.data && res.data.enabled) {
        console.log('检测到HOS门户访问，重定向到OAuth2认证')
        // 获取认证URL
        const authRes = await service.getAuthorizationUrl()
        if (authRes && authRes.success && authRes.data && authRes.data.authUrl) {
          window.location.href = authRes.data.authUrl
          return
        }
      }
    } catch (e) {
      console.error('OAuth2检测失败', e)
    }
  }

  if (store.getters['system/common/routes'].length <= 0) {
    store.dispatch('system/common/loadHostConfig').then(config => {
      const plugins = config.plugins
      store.dispatch('system/common/buildRoutes', plugins).then(routes => {
        // console.log(JSON.stringify(routes))
        router.addRoutes(routes)
      })
    })
  }

  store.commit('system/common/setRoute', to)
  // if (to.matched.length === 0) {
  //   next({ path: '/404' })
  //   return
  // }
  NProgress.start()
  store.commit('d2admin/search/set', false)
  let transition = true
  if (to.meta.transition === false) {
    transition = false
  }
  store.commit('d2admin/transition/set', transition)
  if (to.matched.some(r => r.meta.auth)) {
    const token = util.cookies.get('token')
    if (token && token !== 'undefined') {
      next()
    } else {
      const open = util.cookies.get('open-client')
      if (open) {
        next({
          name: 'info',
          query: { redirect: to.fullPath }
        })
      } else {
        next({
          name: 'login',
          query: {
            redirect: to.fullPath
          }
        })
      }
      NProgress.done()
    }
  } else {
    next()
  }
})

router.afterEach(to => {
  NProgress.done()
  store.dispatch('d2admin/page/open', to)
  util.title(to.meta.title, store.state.system.common.currentHost)
})

export default router
